import React, { FC } from 'react';
import { HomeSlider } from '../../HomeSlider';
import { IOuter } from './Recommended.types';

export const Recommended: FC<IOuter> = ({
  items,
  openExpandedView,
  buyItem,
  onItemClick,
  onItemDoubleClick,
  isItemSelected,
  selectedItems,
  isSecure,
  beginDrag,
  publicMediaCurrentCategory,
  onItemRightClick,
  onNavLeftClick,
  onNavRightClick,
  dataHook,
  currentFolder,
}) => (
  <div>
    <HomeSlider
      dataHook={dataHook}
      items={items}
      buyItem={buyItem}
      onItemClick={onItemClick}
      onItemDoubleClick={onItemDoubleClick}
      isItemSelected={isItemSelected}
      selectedItems={selectedItems}
      isSecure={isSecure}
      beginDrag={beginDrag}
      publicMediaCurrentCategory={publicMediaCurrentCategory}
      openExpandedView={openExpandedView}
      onItemRightClick={onItemRightClick}
      onNavLeftClick={onNavLeftClick}
      onNavRightClick={onNavRightClick}
      currentFolder={currentFolder}
    />
  </div>
);
